import { TRAVEL_INSURANCE_STEPS } from '@app/app/esales/travel/_sections/steps/TRAVEL_INSURANCE_STEPS';

interface UseWizardStepNavigationParams {
    setCurrentStepKey: (key: string) => void;
    setWizardStarted: (started: boolean) => void;
}

export function useWizardStepNavigation({ setCurrentStepKey, setWizardStarted }: UseWizardStepNavigationParams) {
    const onSuccessfulLogin = () => {
        setCurrentStepKey(TRAVEL_INSURANCE_STEPS.POLICYHOLDER_INFORMATION);
    };

    const onChangeNumberOfPersons = () => {
        setCurrentStepKey(TRAVEL_INSURANCE_STEPS.TRAVELERS_SETUP);
    };

    const onEditPolicyholderInfo = () => {
        setCurrentStepKey(TRAVEL_INSURANCE_STEPS.POLICYHOLDER_INFORMATION);
    };

    const changeAgeOfTraveler = () => {
        setCurrentStepKey(TRAVEL_INSURANCE_STEPS.TRAVELERS_SETUP);
    };

    const editTravelers = () => {
        setCurrentStepKey(TRAVEL_INSURANCE_STEPS.INSURED_PERSONS);
    };

    const editTravelConditions = () => {
        setWizardStarted(false);
        setCurrentStepKey(TRAVEL_INSURANCE_STEPS.TRAVELERS_SETUP);
    };

    const editPolicy = () => {
        setCurrentStepKey(TRAVEL_INSURANCE_STEPS.CHOOSE_INSURANCE);
    };

    return {
        onSuccessfulLogin,
        onChangeNumberOfPersons,
        onEditPolicyholderInfo,
        changeAgeOfTraveler,
        editTravelers,
        editTravelConditions,
        editPolicy,
    };
}
